// src/pages/staff-management/components/StaffCard.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";
import Button from "../../../components/ui/Button";

const StaffCard = ({
  member,
  onViewSchedule,
  onEditAvailability,
  onEditProfile,
  onDeleteStaff,
}) => {
  const { t } = useTranslation();
  const getStatusColor = (status) => {
    switch (status) {
      case "active":
        return "bg-success text-success-foreground";
      case "inactive":
        return "bg-error text-error-foreground";
      case "on_leave":
        return "bg-warning text-warning-foreground";
      default:
        return "bg-secondary text-secondary-foreground";
    }
  };

  const getRoleColor = (role) => {
    switch (role) {
      case "Manager":
        return "bg-primary text-primary-foreground";
      case "Staff":
        return "bg-accent text-accent-foreground";
      case "Receptionist":
        return "bg-secondary text-secondary-foreground";
      default:
        return "bg-muted text-muted-foreground";
    }
  };

  return (
    <div className="bg-background rounded-lg border border-border p-4 hover-elevate w-full max-w-xs">
      <div className="flex flex-col gap-4">
        {/* 1. HEADER */}
        <div className="flex items-start justify-between gap-4">
          {/* STÂNGA: avatar + nume + ID */}
          <div className="flex items-center gap-3">
            <div className="w-16 h-16 rounded-full overflow-hidden bg-muted flex-shrink-0">
              <Image
                src={member?.avatar}
                alt={member?.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <div className="min-w-0">
                <h3 className="font-semibold text-foreground truncate">
                  {member?.name}
                </h3>
                <p className="text-sm text-text-secondary">
                  ID: {member?.id}
                </p>
              </div>
              <div className="flex items-end gap-1">
                <span
                  className={`inline-flex items-center px-0 py-1 rounded-full text-xs font-medium ${getRoleColor(
                    member?.role
                  )}`}
                >
                  {member?.role}
                </span>
                <span
                  className={`inline-flex items-center px-3 py-0.5 mx-2 rounded-full text-xs font-medium ${getStatusColor(
                    member?.status
                  )}`}
                >
                  {member?.status === "active"
                    ? t("staff.statusActive")
                    : member?.status === "inactive"
                      ? t("staff.statusInactive")
                      : t("staff.statusOnLeave")}
                </span>
              </div>
            </div>
          </div>
        </div>


        {/* 2. CONTACT */}
        <div className="space-y-2">
          <div className="flex items-center gap-2 text-sm text-foreground min-w-0">
            <Icon name="Mail" size={14} />
            <span className="truncate">{member?.email}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-text-secondary">
            <Icon name="Phone" size={14} />
            <span>{member?.phone}</span>
          </div>
        </div>

        {/* 3. SERVICII */}
        <div>
          <p className="text-sm text-text-secondary mb-2">{t("staff.servicesLabel")}</p>
          <div className="flex flex-wrap gap-1">
            {member?.services?.length ? (
              member.services.map((service, index) => (
                <span
                  key={index}
                  className="inline-flex items-center px-2 py-1 rounded-md text-xs bg-accent/10 text-accent-foreground"
                >
                  {service}
                </span>
              ))
            ) : (
              <span className="text-xs text-muted-foreground">
                {t("staff.noServicesAssigned")}
              </span>
            )}
          </div>
        </div>

        {/* 4. ACȚIUNI */}
        <div className="flex items-center justify-between gap-3 pt-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onEditProfile(member)}
            className="flex items-center gap-2 border border-[#ccc] rounded-sm"
            type="button"
          >
            <Icon name="Edit" size={14} />
            <span>{t("common.edit")}</span>
          </Button>

          <Button
            variant="ghost"
            size="icon"
            onClick={() => onDeleteStaff(member)}
            className="text-error hover:text-error"
            type="button"
          >
            <Icon name="Trash2" size={14} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StaffCard;
